import Highcharts from "highcharts";

// Lazy-load modules and apply them
export const initHighchartsModules = async () => {
  const { default: exporting } = await import("highcharts/modules/exporting");
  // const { default: exportData } = await import(
  //   "highcharts/modules/export-data"
  // );
  // const { default: offlineExporting } = await import(
  //   "highcharts/modules/offline-exporting"
  // );

  exporting(Highcharts);
  // exportData(Highcharts);
  // offlineExporting(Highcharts);

  return Highcharts;
};
